<h2 class="mb-2">Registro de nueva Factura</h2>
<form [formGroup]="facturaForm" (ngSubmit)="onSubmit()">
    <div class="formgrid grid">

        <!-- Número de factura -->
        <div class="field col">
            <label for="numero_factura">Número de Factura*</label>
            <input id="numero_factura" type="text" pInputText formControlName="numero_factura"
                class="p-inputtext-md w-full"
                [ngClass]="{'ng-invalid ng-dirty':getControl('numero_factura').touched && getControl('numero_factura').invalid}" />
            <small class="error" *ngIf="getControl('numero_factura').touched && getControl('numero_factura').invalid">
                <span *ngIf="getControl('numero_factura')?.hasError('required')">
                    Campo obligatorio
                </span>
                <span *ngIf="getControl('numero_factura')?.hasError('maxlength')">
                    Máximo {{getControl('numero_factura').getError('maxlength').requiredLength }} caracteres
                </span>
                <span *ngIf="getControl('numero_factura').hasError('pattern')">
                    Formato inválido
                </span>
                <span *ngIf="getControl('numero_factura').hasError('email')">
                    Correo inválido
                </span>
            </small>
        </div>

        <!-- Fecha -->
        <div class="field col">
            <label for="fecha">Fecha*</label>
            <p-calendar inputId="fecha" formControlName="fecha" dateFormat="dd/mm/yy" class="w-full" [showIcon]="true"
                styleClass="p-inputtext-md p-component w-full"
                [ngClass]="{'ng-invalid ng-dirty':getControl('fecha').touched && getControl('fecha').invalid}"></p-calendar>
            <small class="error" *ngIf="getControl('fecha').touched && getControl('fecha').invalid">
                <span *ngIf="getControl('fecha')?.hasError('required')">
                    Campo obligatorio
                </span>
            </small>
        </div>

        <!-- Usuario -->
        <div class="field col">
            <label for="fk_usuario">Empresa*</label>
            <p-dropdown id="fk_usuario" [options]="usuarios" formControlName="fk_usuario" class="w-full"
                styleClass="p-inputtext-md p-component w-full" panelStyleClass="w-full"
                [ngClass]="{'ng-invalid ng-dirty':getControl('fk_usuario').touched && getControl('fk_usuario').invalid}"
                placeholder="Seleccione un usuario">
            </p-dropdown>
            <small class="error" *ngIf="getControl('fk_usuario').touched && getControl('fk_usuario').invalid">
                <span *ngIf="getControl('fk_usuario')?.hasError('required')">
                    Campo obligatorio
                </span>
            </small>
        </div>

    </div>
    <p-divider></p-divider>
    <!-- Productos dinamicos -->
    <div class="flex justify-content-end mt-2">
        <p-button type="button" label="Agregar Producto" icon="pi pi-plus" (click)="addProducto()">
        </p-button>
    </div>
    <div style="width: 100%;" formArrayName="productos">
        <div *ngFor="let prod of productos.controls; let i = index" [formGroupName]="i"
            class="formgrid grid mb-3 w-full">

            <div class="col-3">
                <label>Tipo de Producto*</label>
                <p-dropdown [options]="tiposProductos" formControlName="fk_tipo_producto" class="w-full"
                    styleClass="p-inputtext-md p-component w-full"
                    [ngClass]="{'ng-invalid ng-dirty': prod.get('fk_tipo_producto')?.invalid && prod.get('fk_tipo_producto')?.touched}"
                    panelStyleClass="w-full" placeholder="Seleccione">
                </p-dropdown>
                <small class="error"
                    *ngIf="prod.get('fk_tipo_producto')?.touched && prod.get('fk_tipo_producto')?.invalid">
                    <span
                        *ngIf="(prod.get('fk_tipo_producto')?.invalid && prod.get('fk_tipo_producto')?.touched) && prod.get('fk_tipo_producto')?.errors?.['required']">
                        Campo obligatorio
                    </span>
                </small>
            </div>

            <div class="col-3">
                <label>Lote*</label>
                <input type="text" pInputText formControlName="lote" class="p-inputtext-md focus:border-primary w-full"
                    [ngClass]="{'ng-invalid ng-dirty': prod.get('lote')?.invalid && prod.get('lote')?.touched}" />
                <small class="error" *ngIf="prod.get('lote')?.touched && prod.get('lote')?.invalid">
                    <span
                        *ngIf="(prod.get('lote')?.invalid && prod.get('lote')?.touched) && prod.get('lote')?.errors?.['required']">
                        Campo obligatorio
                    </span>
                </small>
            </div>

            <div class="col-3">
                <label>Cantidad*</label>
                <input type="number" pInputText formControlName="cantidad_productos"
                    class="p-inputtext-md focus:border-primary w-full"
                    [ngClass]="{'ng-invalid ng-dirty': prod.get('cantidad_productos')?.invalid && prod.get('cantidad_productos')?.touched}" />
                <small class="error"
                    *ngIf="prod.get('cantidad_productos')?.touched && prod.get('cantidad_productos')?.invalid">
                    <span
                        *ngIf="(prod.get('cantidad_productos')?.invalid && prod.get('cantidad_productos')?.touched) && prod.get('cantidad_productos')?.errors?.['required']">
                        Campo obligatorio
                    </span>
                </small>
            </div>

            <div class="col-3">
                <div class="text-left p-4 border-round-sm font-bold">
                    <button type="button" pButton icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        (click)="removeProducto(i)">
                    </button>
                </div>
            </div>

        </div>
    </div>


    <div class="flex justify-content-end mt-4 gap-4">
        <p-button label="Salir" type="button" icon="pi pi-sign-out" styleClass="p-button-secondary"
            (click)="salir()"></p-button>
        <p-button type="submit" label="Guardar" icon="pi pi-save" [disabled]="facturaForm.invalid">
        </p-button>
    </div>
</form>
<p-toast></p-toast>